module.exports = __webpack_public_path__ + "static/img/quote1.12e55ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/quote1.jpg
// module id = K+x2
// module chunks = 0